import { CSSProperties } from 'react';

export const CheckboxUnselected = ({
  className,
  style,
}: {
  className?: string;
  style?: CSSProperties | undefined;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
    style={style}
  >
    <g id="Group_2480" data-name="Group 2480" transform="translate(-940 -695)">
      <rect
        id="Rectangle_2059"
        data-name="Rectangle 2059"
        width="24"
        height="24"
        transform="translate(940 695)"
        fill="none"
      />
      <g id="Group_2478" data-name="Group 2478" transform="translate(918 36)">
        <g id="Group_2438" data-name="Group 2438" transform="translate(24 661)">
          <g id="Group_2412" data-name="Group 2412">
            <g
              id="Rectangle_263"
              data-name="Rectangle 263"
              fill="none"
              stroke="rgba(0,0,0,0.4)"
              strokeWidth="1"
            >
              <rect width="20" height="20" rx="2" stroke="none" />
              <rect x="0.5" y="0.5" width="19" height="19" rx="1.5" fill="none" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
